import apiClient from "./apiClient";

export const getAppModules = () => apiClient.get("/app-modules");
export const getAppModuleById = (id) => apiClient.get(`/app-modules/${id}`);
export const createAppModule = (data) => apiClient.post("/app-modules", data);
export const updateAppModule = (id, data) => apiClient.put(`/app-modules/${id}`, data);
export const deleteAppModule = (id) => apiClient.delete(`/app-modules/${id}`);

export const getAppSubModuleById = (id) => apiClient.get(`/app-sub-modules/${id}`);
export const createAppSubModule = (data) => apiClient.post("/app-sub-modules", data);
export const updateAppSubModule = (id, data) => apiClient.put(`/app-sub-modules/${id}`, data);
export const deleteAppSubModule = (id) => apiClient.delete(`/app-sub-modules/${id}`);
